import { createStyles, Theme } from '@material-ui/core'

export const useSettlementKpiBlockStyles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0',
      minWidth: 0,
      boxSizing: 'border-box',
      padding: theme.spacing(2),
      borderRadius: theme.spacing(1.5),
      border: '1px solid rgba(0,0,0,0.12)',
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 auto'
      }
    },
    // Fase activa: ocupa más espacio y se resalta con el color primario
    active: {
      flex: '2 1 0',
      border: `2px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(2) - 1,
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 auto'
      }
    },
    titleText: {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.palette.text.secondary
    },
    titleTextActive: {
      color: theme.palette.text.primary
    },
    valueText: {
      fontSize: '2.25rem',
      fontWeight: 700,
      lineHeight: 1.1,
      marginTop: theme.spacing(1),
      color: theme.palette.text.secondary
    },
    valueTextActive: {
      color: theme.palette.primary.main
    },
    captionText: {
      fontSize: '0.75rem',
      marginTop: theme.spacing(0.5),
      color: theme.palette.text.secondary
    },
    processing: {
      marginTop: theme.spacing(1.5)
    },
    processingBar: {
      borderRadius: theme.spacing(0.5)
    },
    processingText: {
      fontSize: '0.75rem',
      marginTop: theme.spacing(0.75),
      color: theme.palette.text.secondary
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    rows: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(1),
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // Los botones no se comprimen: caben en la misma fila inferior y, si no hay espacio, se apilan
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      '& .MuiButton-root': {
        whiteSpace: 'nowrap'
      },
      marginTop: 'auto',
      paddingTop: theme.spacing(2)
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1, 1.5),
      borderRadius: theme.spacing(1),
      border: '1px solid rgba(0,0,0,0.12)'
    },
    rowNested: {
      padding: theme.spacing(0.5, 1.5),
      backgroundColor: theme.palette.grey[50]
    },
    nestedRows: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(1),
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(1),
      borderTop: `1px dashed ${theme.palette.divider}`
    },
    rowSelected: {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.selected
    },
    rowHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: theme.spacing(0.5)
    },
    rowClickable: {
      cursor: 'pointer',
      '&:hover $rowIcon': {
        color: theme.palette.primary.main
      },
      '&:hover $rowLabel': {
        color: theme.palette.primary.main
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`
      }
    },
    rowDisabled: {
      opacity: 0.65,
      backgroundColor: theme.palette.grey[100]
    },
    rowValueBox: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(0.5)
    },
    rowIcon: {
      fontSize: '1rem',
      color: theme.palette.text.secondary
    },
    rowLabel: {
      fontSize: '0.875rem'
    },
    rowValue: {
      fontSize: '1.125rem',
      fontWeight: 700
    },
    linkButton: {
      alignSelf: 'flex-start',
      padding: 0,
      minWidth: 0,
      textTransform: 'none'
    }
  })
